import {Component, OnInit} from "@angular/core";
import {ResetPassword} from "../service/member/member";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberService} from "../service/member/member.service";
import {AuthService} from "../service/auth/auth.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [MemberService]
})
export class ResetPasswordComponent implements OnInit {

  token: string;

  /**
   * 특수 문자 : !@#$%^&*~`_-+=:;“‘?/,.\|(){}[]<>
   */
  strongRegex = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\\|\[\]{};:\'",.<>\/?~`&]).{8,}$/i;

  error: boolean = false;

  constructor(private memberService: MemberService,
              private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService) {

    if (this.authService.canActivate()) {
      this.router.navigateByUrl('/');
      return;
    }

    this.route.queryParams.subscribe(
      params => {
        this.token = params['token'];
        if (!this.token) {
          this.router.navigateByUrl('/');
        }
      }
    );
  }

  ngOnInit() {
  }

  onResetPassword(resetPassword: ResetPassword) {

    resetPassword.token = this.token;

    if (!resetPassword.email) {
      window.alert('이메일을 입력해 주세요');
      return;
    } else if (!resetPassword.password) {
      window.alert('패스워드를 입력해 주세요');
      return;
    } else if (!this.strongRegex.test(resetPassword.password)) {
      window.alert('패스워드는 영문 소문자, 숫자, 특수문자 포함 8자 이상으로 입력해 주세요');
      return;
    } else if (resetPassword.password != resetPassword['pw-check']) {
      window.alert('두 패스워드가 일치하지 않습니다.');
      return;
    }

    this.memberService.resetPassword(resetPassword).subscribe(
      res => {
        window.alert('비밀번호를 설정하였습니다. 로그인해 주세요.');
        this.router.navigateByUrl('/login');
      },
      error => this.error = true
    );


  }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts